import React, { Component } from 'react'
import get from 'lodash-es/get'
import _Input from './Input/Input'
import Image from '../Image/Image'
import LinkWrapper from '../LinkWrapper/LinkWrapper'
import noImage from '../Image/no-image.svg'
import ImageExtensions from './Image/image-extensions'

import Tooltip from 'rc-tooltip'

export const Input = ({ onValueChange, ...props }) => {
  const { value, data } = props
  const imageData = value || data
  const onChange = (e) => {
    onValueChange && onValueChange(e.target.value)
  }
  return (
    <_Input
      {...props}
      type='text'
      maxLength='80'
      onChange={onChange}
      icon={imageData ? '' : 'upload'}
    />
  )
}

export class Output extends Component {
  constructor (props) {
    super(props)
    this.state = {
      imgSrc: props.data || props.value
    }
  }

  componentDidMount () {
    this.setImage()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const oldData = prevProps.data || prevProps.value
    const newData = this.props.data || this.props.value
    if (oldData !== newData) {
      this.setImage()
    }
  }

  getExt = (data) => {
    const split = (data && data.split('.')) || []
    return split.pop()
  }

  isImage = (data) => {
    const ext = this.getExt(data)
    const uniqueExtensions = new Set(ImageExtensions)
    return uniqueExtensions.has(ext)
  }

  setImage = async () => {
    let imgSrc = this.props.data || this.props.value
    const ext = this.getExt(imgSrc)
    const isFileImage = this.isImage(imgSrc)
    if (!isFileImage) {
      const { availableFileTypeImages } = await import('./Image/file-types')
      imgSrc = (ext && availableFileTypeImages[ext.toUpperCase()]) ?? availableFileTypeImages.NA
    }
    this.setState({
      imgSrc
    })
  }

  onNoImage = () => {
    this.setState({
      imgSrc: ''
    })
  }

  render () {
    const { width, height, borderRadius, align, hasPreview } = this.props.config || this.props.imageConfig || {}
    const boxStyle = { width: width || '40px', height: height || '40px', borderRadius: borderRadius || '2px' }
    const { imgSrc } = this.state
    if (imgSrc && !!imgSrc.length) {
      const isFileImage = this.isImage(imgSrc)
      const image = <img src={imgSrc} alt={imgSrc} style={boxStyle} onError={this.onNoImage} />
      return (
        <div className={'image-output-container w-100'}>
          {
            hasPreview && isFileImage
              ? <Tooltip
                id={imgSrc}
                overlayClassName={'image-field-tooltip'}
                mouseEnterDelay={0.1}
                overlay={
                  <div className={'popup-image'}>
                    {image}
                  </div>
                }
                placement={'left'}
              >
                {image}
              </Tooltip>
              : <>{image}</>
          }
          <style jsx>{`
        :global(.image-field-tooltip .rc-tooltip-inner),
        :global(.image-field-tooltip .rc-tooltip-arrow) {
          background-color: transparent;
          border-left-color: transparent;
          box-shadow: none;
          opacity: 1;
        }
        .image-output-container {
          display: flex;
          align-items: center;
          justify-content: ${align === 'center' ? 'center' : `flex-${align}`};
        }
        .popup-image :global(img) {
          transform: scale(5) translateX(-50%);
          opacity: 1;
          border-radius: .25rem !important;
          box-shadow: 2px 2px 4px gray;
        }
      `}</style>
        </div>
      )
    }
    return <Image src={noImage} alt={'no-image'} style={boxStyle} respectSize={`width`} imageAlign={align || 'start'} />
  }
}

export const DisplayAs = props => {
  const display = props.displayAs && props.displayAs[0]
  if (display) {
    let { displayType, linkType, value, prefix = '', target } = display
    if (displayType === 'link') {
      let val = get(props.record, value)
      if (linkType === 'none') {
        return <Output {...props} />
      } else {
        return (
          <LinkWrapper
            style={{ color: 'white', width: '100%' }}
            type={linkType}
            link={prefix + (val != null ? val : '')}
            target={target}
          >
            <Output {...props} />
          </LinkWrapper>
        )
      }
    }
  }
}
